import { useEffect, useState } from 'react';
import { toast } from 'material-react-toastify';
import { Box, Typography } from '@mui/material';
import { PaginatedResponse } from '../../interfaces/PaginatedResponse';
import { N11Order } from '../../interfaces/N11/N11Order';
import {
  getDefaultN11OrderFilter,
  N11OrderFilter,
} from '../../interfaces/N11/N11OrderFilter';
import { getN11Orders } from '../../api/N11';
import { Pagination } from '../../interfaces/Pagination';
import { sharedStyles } from '../../utils/Style';
import { Waiting } from '../../components/Waiting/Waiting';
import { N11OrdersTable } from './N11OrdersTable/N11OrdersTable';

export const N11OrdersPage = () => {
  const [orders, setOrders] = useState<PaginatedResponse<N11Order>>({
    data: [],
    totalCount: 0,
  });
  const [filter, setFilter] = useState(getDefaultN11OrderFilter());
  const [loading, setLoading] = useState(false);

  const refreshOrders = (filters?: N11OrderFilter) => {
    setLoading(true);
    getN11Orders(filters ?? filter)
      .then((res) => setOrders(res))
      .catch((err) => toast.error(err.message))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refreshOrders();
  }, []);

  const handlePagination = (p: Pagination) => {
    const newFilter = { ...filter, pagination: p };

    setFilter(newFilter);
    refreshOrders(newFilter);
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Waiting open={loading} />

      <Typography variant='h5' sx={{ ...sharedStyles.pageTitle }}>
        N11 Siparişleri
      </Typography>

      <N11OrdersTable
        orders={orders.data}
        totalCount={orders.totalCount}
        pagination={filter.pagination}
        onPagination={handlePagination}
      />
    </Box>
  );
};
